<div
  class="mob-close block md:hidden"
  [style.margin-top.px]="marginTopPx"
  (click)="click.emit($event)"
>
  <mat-icon fontSet="fa" fontIcon="fa-times"></mat-icon>
</div>
